module.exports = __webpack_public_path__ + "static/media/c.f5e77356.svg";